<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CButton from '@lib/components/CButton/CButton.vue'
import CDrawer from '@lib/components/CDrawer/CDrawer.vue'
import CDrawerContent from '@lib/components/CDrawerContent/CDrawerContent.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import CSpin from '@lib/components/CSpin/CSpin.vue'
import CFilePanel from '@lib/components/CFilePanel/CFilePanel.vue'
import CFileAccessManagement from '@lib/components/CFileAccessManagement/CFileAccessManagement.vue'
import FolderPanel from '@browser/components/Content/Panel/FolderPanel/FolderPanel.vue'
import ItemsPanel from '@browser/components/Content/Panel/ItemsPanel/ItemsPanel.vue'
import NoItemPanel from '@browser/components/Content/Panel/NoItemPanel/NoItemPanel.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import useApiStore from '@browser/stores/api'
import useAppStore from '@browser/stores/app'
import { useSlots, watch } from 'vue'

const { t } = useI18n()
const themeVars = useThemeVars()
const { getters: apiGetters, state: apiState } = useApiStore()
const { selectedFileId, selectedFolderId, selectedItemIds, toggleContentPanel, isContentPanelOpen, isAdmin } =
  useAppStore()

watch([selectedFileId, selectedFolderId, isContentPanelOpen], async () => {
  if (!selectedFileId.value && !selectedFolderId.value) {
    toggleContentPanel()
  }
})

const slots = useSlots()
</script>

<template>
  <CDrawer
    class="component-drawer"
    placement="right"
    show
    :style="{
      border: `1px solid ${themeVars.primary5}`,
      margin: '8px 0px',
      'border-radius': '8px 0px 0px 8px',
    }"
    :width="400"
    :z-index="1500"
    @update:show="toggleContentPanel()"
  >
    <CButton
      class="component-drawer__close-button absolute top-[24px] right-[400px] z-12 rounded mr-1 h-11 w-11"
      :style="{ background: themeVars.primary5, border: `1px solid ${themeVars.primary}` }"
      @click="toggleContentPanel()"
    >
      <template #icon>
        <CIcon icon="close" size="large" />
      </template>
    </CButton>

    <CDrawerContent :closable="false">
      <div class="flex flex-col gap-4 h-full">
        <div class="component-drawer__title">
          {{ t('canvasUI.browserApp.panel.title') }}
        </div>
        <CSpin v-if="apiGetters.isLoading" class="m-a" />
        <template v-else>
          <slot v-if="!!(slots['single-file-details'] && selectedFileId && isAdmin)" name="single-file-details" />
          <template v-else-if="selectedFileId">
            <CFilePanel :file="apiState.selectedFile as any" is-file-browser />
            <CFileAccessManagement :file="apiState.selectedFile as any" />
          </template>
          <FolderPanel v-else-if="selectedFolderId" />
          <ItemsPanel v-else-if="selectedItemIds.length > 1" />
          <NoItemPanel v-else />
        </template>
      </div>
    </CDrawerContent>
  </CDrawer>
</template>

<style lang="scss" scoped>
.component-drawer {
  &__title {
    font-size: 20px;
    line-height: 32px;
    letter-spacing: 0.25px;
  }
}
</style>
